const {h, render, Component} = require('preact');
const {route} = require('preact-router')

const Search = require('./search')

class FAQSearch extends Component {
  constructor(props) {
    super(props);
  }

  handleSearch(searchText){
    route(`/customer_support/web/faq/search?searchText=${searchText}`);
  }

  render() {
    let searchText = "";
    if(this.props.searchText && this.props.searchText.length > 0)
      searchText=this.props.searchText;
    return (
        <div class="row" data-bhw="web2018_faq_search">
          <Search
            handleSearch = {this.handleSearch.bind(this)}
            searchText = {searchText}
          />
      </div>
    )
  }
}

module.exports = FAQSearch
